shadow$provide[417] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying vec2 vSprite;

float getSpriteMask(vec2 xy);
float getSpriteAlpha(float mask);

void setFragmentColorFill(vec4 color) {
  float mask = getSpriteMask(vSprite);
  if (mask > 1.0) {
    discard;
  }
  float alpha = getSpriteAlpha(mask);
  if (alpha < 1.0) {
    discard;
  }
  gl_FragColor = color;
}

`;

};